import React, { useState } from 'react';
import { LayoutDashboard, Gavel, FileCheck, Users, FileText, ArrowLeft, MapPin, Ruler, Building, DollarSign, FileText as FileIcon, Calendar } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link, useParams, useNavigate } from 'react-router-dom';
export function PublicListingDetailPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/authority'
  }, {
    label: 'Auctions',
    icon: Gavel,
    path: '/authority/auctions',
    badge: '3 Active'
  }, {
    label: 'Compliance',
    icon: FileCheck,
    path: '/authority/compliance'
  }, {
    label: 'Public Listings',
    icon: Users,
    path: '/authority/listings'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/authority/reports'
  }];
  const listing = {
    id: id || 'GOV-101',
    plotNumber: 'GOV-2024-001',
    surveyNumber: '45/2/A',
    location: 'Hinjewadi Phase 3, Pune',
    area: '5,000',
    zoning: 'Commercial',
    basePrice: '₹1.5 Cr',
    status: 'Available',
    addedDate: '2024-01-15',
    description: 'Prime commercial land parcel located in Hinjewadi IT Park Phase 3. Direct road access, all utilities available. Suitable for IT park, commercial complex, or mixed-use development.'
  };
  const handleCreateAuction = () => {
    navigate('/authority/auctions/create');
  };
  return <DashboardLayout title="Public Listings" personaLabel="GOVT AUTHORITY" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="GA" data-id="element-2717">
      <div className="max-w-5xl mx-auto" data-id="element-2718">
        <Link to="/authority/listings" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#1f2933] mb-6" data-id="element-2719">
          <ArrowLeft className="w-4 h-4" data-id="element-2720" /> Back to Listings
        </Link>

        {/* Header */}
        <div className="bg-white border border-gray-300 p-8 mb-6" data-id="element-2721">
          <div className="flex items-start justify-between mb-4" data-id="element-2722">
            <div data-id="element-2723">
              <div className="flex items-center gap-3 mb-3" data-id="element-2724">
                <span className="px-3 py-1 bg-green-100 text-green-800 border border-green-200 text-xs font-bold rounded" data-id="element-2725">
                  {listing.status.toUpperCase()}
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs font-bold" data-id="element-2726">
                  {listing.zoning}
                </span>
              </div>
              <h1 className="text-3xl font-bold mb-2" data-id="element-2727">
                Land Parcel {listing.plotNumber}
              </h1>
              <p className="text-gray-500 font-mono text-sm" data-id="element-2728">
                Survey No: {listing.surveyNumber}
              </p>
            </div>
            <div className="text-right" data-id="element-2729">
              <div className="text-sm text-gray-500 mb-1" data-id="element-2730">Base Price</div>
              <div className="text-3xl font-bold" data-id="element-2731">{listing.basePrice}</div>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-6 border-t border-gray-200" data-id="element-2732">
            <div className="flex items-center gap-3" data-id="element-2733">
              <MapPin className="w-5 h-5 text-gray-400" data-id="element-2734" />
              <div data-id="element-2735">
                <div className="text-xs text-gray-500" data-id="element-2736">Location</div>
                <div className="font-bold text-sm" data-id="element-2737">{listing.location}</div>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-2738">
              <Ruler className="w-5 h-5 text-gray-400" data-id="element-2739" />
              <div data-id="element-2740">
                <div className="text-xs text-gray-500" data-id="element-2741">Total Area</div>
                <div className="font-bold text-sm" data-id="element-2742">{listing.area} Sq. Ft</div>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-2743">
              <Building className="w-5 h-5 text-gray-400" data-id="element-2744" />
              <div data-id="element-2745">
                <div className="text-xs text-gray-500" data-id="element-2746">Zoning</div>
                <div className="font-bold text-sm" data-id="element-2747">{listing.zoning}</div>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-2748">
              <Calendar className="w-5 h-5 text-gray-400" data-id="element-2749" />
              <div data-id="element-2750">
                <div className="text-xs text-gray-500" data-id="element-2751">Added</div>
                <div className="font-bold text-sm" data-id="element-2752">{listing.addedDate}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="bg-white border border-gray-300 p-8 mb-6" data-id="element-2753">
          <h2 className="text-xl font-bold mb-4" data-id="element-2754">Description</h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-2755">{listing.description}</p>
        </div>

        {/* Documents */}
        <div className="bg-white border border-gray-300 p-8 mb-6" data-id="element-2756">
          <h2 className="text-xl font-bold mb-4" data-id="element-2757">Land Documents</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2758">
            {['7/12 Extract', 'Survey Map', 'Zoning Certificate'].map((doc, i) => <div key={i} className="p-4 border border-gray-200 bg-gray-50 flex items-center gap-3" data-id="element-2759">
                  <FileIcon className="w-5 h-5 text-gray-400" data-id="element-2760" />
                  <div className="flex-1" data-id="element-2761">
                    <div className="font-bold text-sm" data-id="element-2762">{doc}</div>
                    <div className="text-xs text-gray-500" data-id="element-2763">PDF • 2.4 MB</div>
                  </div>
                  <button className="text-xs text-blue-600 hover:underline" data-id="element-2764">
                    View
                  </button>
                </div>)}
          </div>
        </div>

        {/* Actions */}
        <div className="bg-blue-50 border border-blue-200 p-6 flex items-center justify-between" data-id="element-2765">
          <div data-id="element-2766">
            <h3 className="font-bold mb-1" data-id="element-2767">Ready to Auction?</h3>
            <p className="text-sm text-gray-700" data-id="element-2768">
              Create an auction for this land parcel to start accepting bids.
            </p>
          </div>
          <button onClick={handleCreateAuction} className="px-6 py-3 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800 flex items-center gap-2" data-id="element-2769">
            <Gavel className="w-4 h-4" data-id="element-2770" />
            Create Auction
          </button>
        </div>
      </div>
    </DashboardLayout>;
}